export const webview = {
  webviewContent: 'Questa è un URL esterno e verrà aperto in una nuova finestra. Aprire?',
  webviewButtonOpenTitle: 'Apri',
  webviewButtonCopyTitle: 'Copia URL',
  webviewButtonOpenAgainTitle: 'Apri di nuovo',
  notifications: {
    urlCopied: 'URL copiato!'
  }
}
